import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from "../Aside";
import Footer from '../../components/Footer/';
// Views
import Dashboard from '../../containers/Dashboard/';
// Styles
// Import Flag Icons Set
// import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../../../scss/style.scss'
import '@coreui/icons-pro/css/linear.min.css';
// Temp fix for reactstrap
import '../../../scss/core/_dropdown-menu-right.scss'
import ApplicationsList from "../../containers/Applications/ApplicationsList";
import ApplicationForm from "../../containers/Applications/ApplicationForm";
import ApplicationSubmit from "../../containers/Applications/ApplicationSubmit";
import CameraList from "../../containers/Camera/CameraList";
import {MediaList} from "../../containers/Camera/MediaList";
import CareerApplicantList from "../../containers/Careers/CareerApplicantList";
import {CareerAccessList} from "../../containers/Careers/CareerAccessList";
import {Calendar} from "../../containers/Calendar/Calendar";
// import BannerList from "../../containers/Admin/SplashBanner/BannerList";
import DebtCalc from "../../containers/DebtCalc/DebtCalc";
import Briefcase from "../../containers/Briefcase/Briefcase";
import {EventClient} from "../../util/eventClient";
import {LeadSearch} from "../../containers/Leads/LeadSearch";
import LMSEntryEditor from "../../containers/Leads/modals/LMSEntryEditor";
import {TaxCenter} from "../../containers/Leads/TaxCenter";
import {PolicySearch} from "../../containers/Leads/PolicySearch";
import {Store} from "../../containers/Store/Store";
import {Resources} from "../../containers/Resources/Resources";
import {Training} from "../../containers/Training/Training";
import {Events} from "../../containers/Events/Events";
import {Reviews} from "../../containers/Reviews/Reviews";
import {LeadBrowse} from "../../containers/Leads/LeadBrowse";
import {CalendarEntryEditorDialog} from "../../containers/Calendar/modals/CalendarEntryEditorDialog";
import {ConfirmDialogEvent} from "../../containers/Shared/ConfirmDialogEvent";
import {Email} from "../../containers/Email/Email";
import IntakeList from "../../containers/Intakes/IntakeList";
import {UserList} from "../../containers/Admin/Users/UserList";
import BannerList from "../../containers/Admin/SplashBanner/BannerList";
import {UserAddEdit} from "../../containers/Admin/Users/UserAddEdit";
import {MyCalendar} from "../../containers/Timeclock/MyCalendar";
import LMSDuplicateLookup from "../../containers/Leads/modals/LMSDuplicateLookup";


class Home extends Component {
  componentWillMount() {
    EventClient.on('NAVIGATE', (data) => {
      if (typeof data === "object" && data.hasOwnProperty('path')) {
        this.props.history.push(data.path, data.data || undefined)
      } else {
        this.props.history.push(data)
      }
    }, "Home")
  }

  componentWillUnmount() {
    EventClient.off('NAVIGATE', (data) => this.props.history.push(data), "Home");
  }

  render() {
    return (
      <div className="app">
        <Header perms={this.props.perms || {}}/>
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            {/*<Breadcrumbs*/}
            {/*  wrapperElement="ol"*/}
            {/*  wrapperClass="breadcrumb"*/}
            {/*  itemClass="breadcrumb-item"*/}
            {/*  separator=""*/}
            {/*  routes={this.props.routes}*/}
            {/*  params={this.props.params}*/}
            {/*/>*/}
            <Container fluid>
              <Switch>
                <Route path="/home"
                       name="Dashboard"
                       render={(props) => <Dashboard {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}
                />
                <Route exact={true}
                       path="/applications"
                       name="CoursesList"
                       render={(props) => <ApplicationsList {...props} token={this.props.token}
                                                            perms={this.props.perms} isAuthed={true}
                                                            mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/applications/add"
                       name="CoursesForm"
                       render={(props) => <ApplicationForm {...props} action="add"
                                                           token={this.props.token}
                                                           perms={this.props.perms} isAuthed={true}
                                                           mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/applications/edit_:id"
                       name="CoursesForm"
                       render={(props) => <ApplicationForm {...props} action="edit"
                                                           token={this.props.token}
                                                           perms={this.props.perms} isAuthed={true}
                                                           mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/applications/submit_:id"
                       name="CoursesForm"
                       render={(props) => <ApplicationSubmit {...props} action="edit"
                                                             token={this.props.token}
                                                             perms={this.props.perms} isAuthed={true}
                                                             mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/cameras"
                       name="CameraList"
                       render={(props) => <CameraList {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/cameras/viewmedia"
                       name="MediaList"
                       render={(props) => <MediaList {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/cameras/viewmedia/:uuid"
                       name="MediaList"
                       render={(props) => <MediaList {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/careers/applicants"
                       name="CareerApplicantList"
                       render={(props) => <CareerApplicantList {...props} token={this.props.token}
                                                               perms={this.props.perms} isAuthed={true}
                                                               mainCtrl={this}/>}
                />
                <Route exact={true}
                       path="/careers/access"
                       name="CareerAccessList"
                       render={(props) => <CareerAccessList {...props} token={this.props.token}
                                                            perms={this.props.perms} isAuthed={true}
                                                            mainCtrl={this}/>}/>
                <Route exact={true}
                       path="/calendar/:cal_id/followup/:lead_id"
                       name="MyCalendar"
                       render={(props) => <Calendar {...props} token={this.props.token}
                                                    followup={true}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/calendar/:cal_id/schedule/:lead_id"
                       name="MyCalendar"
                       render={(props) => <Calendar {...props} token={this.props.token}
                                                    followup={false}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/calendar/:cal_id"
                       name="MyCalendar"
                       render={(props) => <Calendar {...props} token={this.props.token}
                                                    followup={false}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/calendar"
                       name="Calendar"
                       render={(props) => <Calendar {...props} token={this.props.token}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>

                {/*<Route exact={true}*/}
                {/*       path="/admin/banners"*/}
                {/*       name="Banners"*/}
                {/*       render={(props) => <BannerList {...props} token={this.props.token}*/}
                {/*                                      perms={this.props.perms} isAuthed={true}*/}
                {/*                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>*/}

                <Route exact={true}
                       path="/debtcalc"
                       name="DebtCalc"
                       render={(props) => <DebtCalc {...props} token={this.props.token}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/briefcase"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/-2"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     folder_id={-2} agency_id={0} month={0}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/:folder_id"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/-2/callback"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     folder_id={-2} agency_id={0} month={0}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/-2/callback/:agency_id"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     folder_id={-2} month={0}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/-2/callback/:agency_id/:month"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     folder_id={-2}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/-2/callback/:agency_id/:month/:file_id"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     folder_id={-2}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/briefcase/:folder_id/:file_id"
                       name="Briefcase"
                       render={(props) => <Briefcase {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>


                <Route exact={true}
                       path="/lookup/search"
                       name="LMS"
                       render={(props) => <LeadSearch {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/lookup/policies"
                       name="Policy Lookup"
                       render={(props) => <PolicySearch {...props} token={this.props.token}
                                                        perms={this.props.perms} isAuthed={true}
                                                        mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/leads/:folder_id"
                       name="LMS"
                       render={(props) => <LeadBrowse {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/leads"
                       name="LMS"
                       render={(props) => <LeadBrowse {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/taxes"
                       name="LMS"
                       render={(props) => <TaxCenter {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/store"
                       name="Store"
                       render={(props) => <Store {...props} token={this.props.token}
                                                 perms={this.props.perms} isAuthed={true}
                                                 mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/resources"
                       name="Resources"
                       render={(props) => <Resources {...props} token={this.props.token}
                                                     perms={this.props.perms} isAuthed={true}
                                                     mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/training"
                       name="Training"
                       render={(props) => <Training {...props} token={this.props.token}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/events"
                       name="Events"
                       render={(props) => <Events {...props} token={this.props.token}
                                                  perms={this.props.perms} isAuthed={true}
                                                  mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/reviews"
                       name="Reviews"
                       render={(props) => <Reviews {...props} token={this.props.token}
                                                   perms={this.props.perms} isAuthed={true}
                                                   mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/lookup/intakes"
                       name="Intakes"
                       render={(props) => <IntakeList {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/timeclock/:user_id"
                       name="TimeClock"
                       render={(props) => <MyCalendar {...props} token={this.props.token}
                                                      followup={false}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>
                <Route exact={true}
                       path="/timeclock"
                       name="TimeClock"
                       render={(props) => <MyCalendar {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>


                <Route exact={true}
                       path="/myemail"
                       name="My Email"
                       render={(props) => <Email {...props} token={this.props.token}
                                                 perms={this.props.perms} isAuthed={true}
                                                 mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/admin/banners"
                       name="Splash Banners"
                       render={(props) => <BannerList {...props} token={this.props.token}
                                                      perms={this.props.perms} isAuthed={true}
                                                      mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/admin/users"
                       name="Users"
                       render={(props) => <UserList {...props} token={this.props.token}
                                                    perms={this.props.perms} isAuthed={true}
                                                    mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Route exact={true}
                       path="/admin/users/:user_id"
                       name="Users"
                       render={(props) => <UserAddEdit {...props} token={this.props.token}
                                                       perms={this.props.perms} isAuthed={true}
                                                       mainCtrl={this} loginID={this.props['loginID']}/>}/>

                <Redirect from="/" to="/home"/>
              </Switch>
              <LMSEntryEditor token={this.props.token} perms={this.props.perms}/>
              <CalendarEntryEditorDialog token={this.props.token} perms={this.props.perms}/>
              <ConfirmDialogEvent/>
              <LMSDuplicateLookup/>
            </Container>
          </main>
          <Aside/>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/index.js